import {Row, Col} from "antd"
import {FormLabel} from "components/Form"
import {BaseInput} from "components/inputs"
import styles from "./ChangeCourseStatusPopup.module.css"
import {BaseLoading} from "components"

type Props = {
    info: any
    isLoading: boolean
    onChangeInfo: (key, value) => void
}

export function CourseGradeForm({info, isLoading, onChangeInfo}: Props) {
    return (
        <div className={styles.courseGradeWrap}>
            <BaseLoading isShow={isLoading} />
            <FormLabel label="Course Grade" />
            <Row gutter={[24, 12]}>
                <Col span={12}>
                    <div>
                        <FormLabel label="Total" />
                        <div className={styles.inputWrap}>
                            <BaseInput
                                disabledArrow
                                className={styles.inputGrade}
                                type="number"
                                value={info.totalValue}
                                onChange={(newValue) => onChangeInfo("totalValue", newValue)}
                            />
                        </div>
                    </div>
                </Col>
                <Col span={12}>
                    <div>
                        <FormLabel label="Weight AVG" />
                        <div className={styles.inputWrap}>
                            <BaseInput
                                disabledArrow
                                className={styles.inputGrade}
                                type="number"
                                value={info.weightedAvgValue}
                                onChange={(newValue) => onChangeInfo("weightedAvgValue", newValue)}
                            />
                            <span className={styles.extraInput}>/ 100</span>
                        </div>
                    </div>
                </Col>
                <Col span={12}>
                    <div>
                        <FormLabel label="Alpha" />
                        <BaseInput
                            className={styles.inputGrade}
                            value={info.alphaValue}
                            onChange={(newValue) => onChangeInfo("alphaValue", newValue)}
                        />
                    </div>
                </Col>
                <Col span={12}>
                    <div>
                        <FormLabel label="Point" />
                        <BaseInput
                            disabledArrow
                            className={styles.inputGrade}
                            type="number"
                            value={info.gpaValue}
                            onChange={(newValue) => onChangeInfo("gpaValue", newValue)}
                        />
                    </div>
                </Col>
            </Row>
        </div>
    )
}
